import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  letterType: { key: 'inquiry', value: 'Letter of Inquiry', text: 'Letter of Inquiry' }
}

const documentGeneratorSlicev2 = createSlice({
  name: 'document-generator-v2',
  initialState,
  reducers: {
    changeLetterType: (state, action) => {
      state.letterType = action.payload;
    }
  }
})

export const {
  changeLetterType
} = documentGeneratorSlicev2.actions;

export default documentGeneratorSlicev2.reducer;